import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { push } from "react-router-redux";

import { Avatar, FlowBox, LinkButton } from "../../../../core/atoms/atoms";
import { LocationCard } from "@travellocal/ui";
import { GoogleAnalyticsHelper } from "@travellocal/ui";
import { HeadingWithDescription } from "./../../../../core/atoms/atoms";
import { HeadingWithIntro } from "./../../../../core/atoms/atoms";
import { WeatherChart } from "./../../../../core/molecules/weatherChart";
import { ItinerarySummaryView } from "./../../../../shared/itinerarySummaryView";
import { MapWrapper } from "./../../../../shared/organisms/mapboxMap";
import { FrequentlyAskedQuestionsContent } from "./../../../components/static/FrequentlyAskedQuestionsContent";
import * as WebRoutes from "@travellocal/utils/webRoutes";

interface StateProps {
  sampleItinerary: IState<ISampleItinerarySummary>;
}

interface DispatchProps {
  navigate: (route: string) => void;
}

export class ItinerarySummaryComponent extends React.Component<StateProps & DispatchProps, {}> {
  public render() {
    const itinerary = this.props.sampleItinerary.data;
    const lto = itinerary.lto;
    const primaryLocation = itinerary.primaryLocation;
    const locationRegion = itinerary.locations.find(itin => itin.slug === primaryLocation.slug);

    const enquireRouteParams = {
      locationSlug: primaryLocation ? primaryLocation.slug : null,
      itineraryId: itinerary.id,
      campaign: "trip-idea-2",
    };
    const enquireRoute = WebRoutes.enquiryForm(enquireRouteParams);

    return (
      <div className="width-wrapper columns is-marginless is-multiline itinerary-body">
        <div className="column is-paddingless is-full is-9-desktop">
          <div className="lto-summary-message">
            <div className="message">
              <Avatar source={lto.image ? lto.image.regularUrl : null} size={Avatar.UISizes.large} />
              <p>{itinerary.description}</p>
            </div>

            {!itinerary.isGroupTour && (
              <FlowBox className="cta-bar">
                <p><i>We will tailor this trip to you. Change anything - from excursions to accommodation{" "}
                  to places visited.</i></p>
                <LinkButton buttonClass="primary-button" className="heading--4 nowrap inverted" to={enquireRoute}>
                  Create your trip
                </LinkButton>
              </FlowBox>
            )}
            {itinerary.isGroupTour && (
              <FlowBox className="cta-bar">
                <p><i>This is a group tour, with a fixed itinerary and scheduled start dates.{" "}
                  Enquire now to find out more.</i></p>
                <LinkButton buttonClass="primary-button" className="heading--4 nowrap inverted" to={enquireRoute}>
                  Enquire now
                </LinkButton>
              </FlowBox>
            )}
          </div>

          <ItinerarySummaryView lto={itinerary.lto} itinerary={itinerary} />
        </div>

        <div className="sidebar column is-full is-3-desktop">
          {primaryLocation &&
            <LocationCard
              location={locationRegion}
              onClick={() => GoogleAnalyticsHelper.logEvent("Select Country", "Click", "Itinerary page card")}
            />
          }
          {primaryLocation &&
            <MapWrapper height={200} markerLocation={itinerary.geoLocations} readonly={true} />
          }
          <p className="m-top-small m-bottom-xxsmall">
            <Link to={WebRoutes.aboutHowItWorks()}>How does TravelLocal work?</Link>
          </p>
          <p className="m-top-small m-bottom-xxsmall">
            <Link to={WebRoutes.aboutLocalExperts()}>Why should I use TravelLocal?</Link>
          </p>

          <div className="clearfix" />
          {primaryLocation?.whenToGo &&
            <div className="weather-info">
              <HeadingWithIntro
                headingStyle={HeadingWithDescription.HeadingStyle.heading}
                headingElement={HeadingWithIntro.HeadingElement.h2}
                title=""
                description="WHEN TO GO"
              />
              <p>
                {itinerary.primaryLocation.whenToGo}
              </p>
            </div>
          }
          {primaryLocation?.whenToGo &&
            <div className="weather-info">
              <HeadingWithIntro
                headingStyle={HeadingWithDescription.HeadingStyle.heading}
                headingElement={HeadingWithIntro.HeadingElement.h2}
                title=""
                description="TEMPERATURE GUIDE"
              />
              <WeatherChart weatherData={itinerary.primaryLocation.weather} />
            </div>
          }
          <FrequentlyAskedQuestionsContent />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch): DispatchProps => {
  return {
    navigate: (route: string) => dispatch(push(route)),
  };
};

const mapStateToProps = (state: IWebStoreState): StateProps => {
  return {
    sampleItinerary: state.sampleItinerary,
  };
};

export const ItinerarySummary = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItinerarySummaryComponent);
